module.exports = __webpack_public_path__ + "img/blog-icon.5d9f9b2c.svg";